import { getTranslatedText } from '@nile/components';

export const getTicketConversationsImportFields = (intl) => {
  const ticketConversationsFields = [
    {
      label: 'attribute.ticket.referenceId',
      key: 'ticketSourceReferenceId',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.type',
      key: 'type',
      type: 'select',
      selectOptions: [
        {
          label: 'TECH_REPLY',
          value: 'TECH_REPLY'
        },
        {
          label: 'REQ_REPLY',
          value: 'REQ_REPLY'
        },
        {
          label: 'DESCRIPTION',
          value: 'DESCRIPTION'
        }
      ],
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    // {
    //   label: 'attribute.ticketId',
    //   key: 'ticketId',
    //   validators: [
    //     {
    //       validate: 'required',
    //       errorMessage: 'dromo.validation.requiredField'
    //     }
    //   ]
    // },
    {
      label: 'attribute.from',
      key: 'fromEmailAddress',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
          errorMessage: 'domain.validation.emailAddress'
        },
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.to',
      key: 'toRecipients',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          // multiple email regex
          regex: '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}[;\\s]*)+$',
          errorMessage: 'domain.validation.emailAddress'
        },
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ],
      description: getTranslatedText(intl, 'dromo.description.multipleEmails')
    },
    {
      label: 'admin.emailNotification.cc',
      key: 'ccRecipients',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          // multiple email regex
          regex: '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}[;\\s]*)+$',
          errorMessage: 'domain.validation.emailAddress'
        }
      ],
      description: getTranslatedText(intl, 'dromo.description.multipleEmails')
    },
    {
      label: 'admin.emailNotification.bcc',
      key: 'bccRecipients',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          // multiple email regex
          regex: '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}[;\\s]*)+$',
          errorMessage: 'domain.validation.emailAddress'
        }
      ],
      description: getTranslatedText(intl, 'dromo.description.multipleEmails')
    },
    // {
    //   label: 'attribute.subject',
    //   key: 'subject',
    //   type: 'string'
    // },
    {
      label: 'asset.details.agent.attachments',
      key: 'attachments',
      type: 'string'
    },
    {
      label: 'attribute.content',
      key: 'content',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'client.new.workingtime.time',
      key: 'time',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?$',
          errorMessage: 'dromo.validation.dateTime'
        },
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    }
  ];

  return ticketConversationsFields;
};
